const attendees = {
	title: "Attendees",
	new_attendee: "New Attendee",
	edit_attendee: "Edit Attendee",
	view_attendee: "View Attendee",
	list_title: "List of Attendees",
	list_subtitle: "Manage Attendee",
	create_title: "Create New Attendee",
	update_title: "Update Attendee",
	address_title: "Address",
	details_title: "Attendee Details",
	other_title: "Other Details",
	id: "ID",
	course_id: "Course",
	participant_id: "Student",
	driving_test_id: "Driving Test",
	enrolled_organisation_id: "Organisation",
	enrolled_date: "Enrolment Date",
	confirmation_sent: "Confirmation Sent?",
	certificate_emailed: "Certificate Emailed?",
	course_attended: "Course Attended",
	course_photo_taken: "Course Photo Taken",
	course_practice_completed: "Course Practice Completed",
	course_completed: "Course Completed",
	comment: "Comment",
	created_by: "Created By",
	student_name: "Student Name",
	image: "Image",
	req_course_completed: "Req module or course completed",
	documents_provided: "Required documents provided",
	met_up_days: "Met up (day)",
	theory_test: "Theory Test",
	certificate: "Certificate",
	filename: "Filename",
	mime: "Mime",
	path: "Path",
	size: "Size",
	accomplishment: "Accomplishment",
	accomplishment_for: "Accomplishment for {course_name}",
	expertise_checked_confirm: "Certificates for the selected participants will be generated or removed. Would you like to proceed?",
	total_percentage_of_student: "Total % for student",
	total_percentage: "Total %",
	release_certificate: "Release certificate",
	course_certificate: "Course certificate",
	certificate_chk: "Certificate",
	certificate_created_on_by: "Certificate created on {date} by {name}",
	mandatory_module_required: "Not all mandatory modules has been selected for this student.",
	birthday_required: "Birthday is mandatory. Please set it for the student.",
	accomplishment_mandatory_addedupdated_confirm: "At least one of the students has completed the course. If you add this mandatory module/option the completion status will be removed. Would you like to proceed?",
	accomplishment_long_course_update_success: "Student expertise updated and is available for students.",
	delete_selected_confirmation: "Selected attendees will be deleted. Would you proceed?",
	set_completion_date: "Set course completion date",
};
export default attendees;